import * as React from 'react';

import { Icon } from '@column/column-ui-kit';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@column/ui';

interface Props {
  content: string;
}

export const RestrictedBadge: React.FC<Props> = ({ content }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="absolute top-2 right-2 flex rounded-md bg-red-500/15 px-[3px] py-[3px] text-destructive dark:bg-red-500/25 dark:text-red-400">
          <Icon.AnimationLock className="[--icon-size-x:14px] [--icon-size-y:14px]" />
          <span className="sr-only">Restricted</span>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{content}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
